module.exports = __webpack_public_path__ + "media/ebba1-1600x1600-15Mbps.ffc42a55.mp4";